import { forwardRef } from 'react';
import { Select as TUISelect, SelectProps } from '@apia/theme';

export type TSelect = SelectProps & { readOnly?: boolean };

const Select = forwardRef<HTMLSelectElement, TSelect>((props, ref) => {
  return (
    <TUISelect
      {...props}
      ref={ref}
      variant={props.variant ?? 'forms.select'}
      className={`${props.className ?? ''} ${props.readOnly ? 'readonly' : ''}`}
      onMouseDown={
        props.readOnly
          ? (ev) => {
              ev.preventDefault();
            }
          : undefined
      }
      onKeyDown={
        props.readOnly
          ? (ev) => {
              if (ev.code !== 'Tab') ev.preventDefault();
            }
          : undefined
      }
    />
  );
});

export default Select;
